import { render, staticRenderFns } from "./WebSocketStatus.vue?vue&type=template&id=963bb8c8&"
import script from "./WebSocketStatus.vue?vue&type=script&lang=ts&"
export * from "./WebSocketStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports